/* tslint:disable:indent */
import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Group} from '../../model/group';
import {SubGroup} from '../../model/sub-group';
import {Field} from '../../model/field';
import {StepperBuilderService} from '../../../../avisDePub/creer/services/stepper.builder.service';
import {EformsSubjectService} from '../../services/eforms-subject.service';
import {Preference} from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import {EformDataService} from '../../services/eform-data.service';
import {EformConditionsService} from '../../services/eform-conditions.service';
import {EFormsOrgService} from '../../services/e-forms-org.service';
import {EformElementsService} from '../../services/efom-elements.service';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import { EformDuplicableEntityService } from '../../services/eform-duplicable-entity.service';
import {EformConditionsV2Service} from '../../services/eform-conditions-v2.service';
import {EformAccordionService} from '../../services/eform-accordion.service';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['../e-forms-generator/e-forms-generator.component.css']
})
export class GroupComponent implements OnInit, AfterViewInit {
  @Input() disableAccordion: boolean = false;
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() group: Group = {} as Group;
  @Input() noticeValue: any = {};
  @Output() newGroup = new EventEmitter();
  @Output() deleteGroup = new EventEmitter();
  @Input() repeatablePath: string;
  @Input() repeatablePathWithIndex: string;
  @Input() prefixId: string;
  @Input() subSectionId: string;
  @Input() parentsChild: any;
  @Input() indexGrp: string = '';
  @Input() linkForRouter: string;
  @Input() index: string;
  @Input() getRepeatablePathWithIndexForGroup: (Group) => string;
  @Input() getRepeatablePathForDuplicableElementFromParent: () => string;
  @Output() preferenceSelected = new EventEmitter<Preference>();

  repeatablePathForElementDuplicable: string;

  constructor(private stepperBuilderService: StepperBuilderService, private eformsSubjectService: EformsSubjectService,
    private eformDuplicableEntityService: EformDuplicableEntityService,
              private eformDataService: EformDataService, private eformConditionService: EformConditionsService, private eFormsOrgService: EFormsOrgService, private eformElementsService: EformElementsService, private canNavigateInStepperService: CanNavigateInStepperService,
              private eformConditionsV2Service: EformConditionsV2Service, private eformAccordionService: EformAccordionService) {
  }

  ngOnInit(): void {
    //Suppression temporaire du point de contact spécifique
    if(this.group?.subGroups){
      this.group.subGroups = this.group.subGroups.filter(g=>g.id !='GR-Touch-Point');
    }

    this.repeatablePathWithIndex = this.getRepeatablePathWithIndexForGroup(this.group);
    this.repeatablePathForElementDuplicable = this.getRepeatablePathForDuplicableElementFromParent();
  }

  ngAfterViewInit() {
    //Dans le cas de l'edition, on cherche les elements répétable à initialiser
    // 🔧 FIX 2026-02-11: Ne pas créer automatiquement des éléments pour les groupes nouvellement ajoutés manuellement
    // Un groupe ajouté manuellement a un ID avec un suffixe _N (ex: GR-Tenderer_1)
    // Seul le groupe original (sans suffixe numérique, ou _0) doit déclencher la création automatique
    const isManuallyAddedGroup = this.group?.id?.includes('_') && !this.group?.id?.endsWith('_0');

    let elementToCreate = this.eformConditionService.findElementsToCreate(this.group, this.repeatablePathWithIndex, this.noticeValue);

    if (elementToCreate?.length && !isManuallyAddedGroup) {
      // ✅ FIX 2026-03-23: Passer isInitializing=true pour que sub-section.newGroup
      // sache que c'est une initialisation (chargement) et non une action utilisateur.
      // Cela évite de déclencher une sauvegarde prématurée pendant le chargement.
      elementToCreate.forEach(e => {
        this.addGroup(true);
      });
    }
    // ✅ FIX 2026-02-02: Ne pas ajouter une organisation ici si c'est un avis lié (isAvisLieCreate)
    // car le stepper.component.ts gère déjà l'ajout de la 2ème organisation pour les avis liés
    // Cela évite le double ajout qui créait 3 organisations au lieu de 2
    // ✅ FIX 2026-02-04: Correction du timing - utiliser linkForRouter.includes('creerAvisPub')
    // est suffisant pour détecter le mode création car cette URL n'est utilisée QUE pour la création
    // (l'édition utilise 'editerAvisPub'). On supprime la vérification de isCreationButBeforeFirstSave
    // qui posait un problème de timing (valeur non encore initialisée lors du ngAfterViewInit)
    if (this.eFormsOrgService.getNeedSecondOrganization() && this.group.id == "GR-Organisations" && this.parentsChild?.length < 2 && this.linkForRouter?.includes('creerAvisPub') && !this.canNavigateInStepperService.isAvisLieCreate) {
      this.addGroup();
    }
  }

  private isDeletable(elementId) {
    let baseId = elementId;
    if (elementId.includes('_')) {
      baseId = elementId.split('_')[0];
    }
    let filteredElements = this.group.subGroups.filter(el => el.id === baseId || el.id.includes(baseId + '_'));
    //Si on en a plus d'un le bouton supprimer doit etre dispo sur toutes
    if (filteredElements.length > 1) {
      filteredElements.forEach(s => s.deletable = true);
    } else {
      //Sinon aucun bouton supprimer
      filteredElements.forEach(s => s.deletable = false);
    }
  }

  isInteger(indexGrp) {
    return Number.isInteger(indexGrp);
  }

  getIncr(id) {
    return id.split('_').slice(-1) == undefined ? 0 : id.split('_').slice(-1);
  }

  addGroup(isInitializing = false) {
    // ✅ FIX 2026-03-23: Passer isInitializing pour que le parent (sub-section)
    // distingue une création automatique (chargement) d'une action utilisateur ("+").
    this.newGroup.emit({data: this.group, isInitializing});
  }

  removeGroup() {
    this.deleteGroup.emit({group: this.group, repeatablePathWithIndex: this.repeatablePathWithIndex});
  }

  newSubGroup($event: any) {
    // Extraire les données et le flag d'initialisation
    const isInitializing = $event?.isInitializing || false;
    const subGroup: SubGroup = Object.assign({}, JSON.parse(JSON.stringify($event?.data || $event)));

    const ids: any = this.group.subGroups.map(gr => gr.id);
    subGroup.subSubGroups = this.eformElementsService.clearRepeatedGroups(subGroup.subSubGroups);

    //Suppression temporaire du point de contact spécifique dans les subSubGroups
    if(subGroup?.subSubGroups){
      subGroup.subSubGroups = subGroup.subSubGroups.filter(g=>g.id !='GR-Touch-Point');
    }

    let elementNumber = 1;
    if (subGroup.id.includes("_")) {
      subGroup.repeatedId = subGroup.id.split('_').slice(1).map(Number);
      subGroup.id = subGroup.id.split('_').slice(0, -1).join('_');
    } else {
      subGroup.repeatedId = [0];
    }
    // On cherche le premier id disponible pour le nouveau sous-groupe
    while (ids.includes(subGroup.id + '_' + elementNumber)) {
      elementNumber++;
    }

    subGroup.id = subGroup.id.split('_')[0];
    subGroup.repeatedId.splice(-1, 1, elementNumber);
    subGroup.repeatedId.forEach(id => subGroup.id += '_' + id);

    subGroup.subSubGroups = this.eformElementsService.updateIdsRecursively(subGroup.subSubGroups, [...subGroup.repeatedId]);

    let seekingId = subGroup.id.split('_').slice(0, -1).join("_");
    const regex = new RegExp(`^${seekingId}`);
    this.group.subGroups.splice(ids.findLastIndex(value => regex.test(value)) + 1, 0, subGroup);
    this.repeatablePath = subGroup.jsonPath + '_SEPSEP_' + (elementNumber);
    this.isDeletable(subGroup.id);

    // NE PAS sauvegarder lors de l'initialisation (chargement des données existantes)
    if (!isInitializing) {
      this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);

      // 🔧 FIX 2026-04-21: Forcer le rescan des flatFields après ajout d'un sous-groupe répétable
      // pour que les conditions COUNT_* (ex: OPT-170-Tenderer "Chef de file") soient réévaluées
      // immédiatement avec le nouveau nombre d'éléments.
      setTimeout(() => {
        this.eformConditionsV2Service.forceRescanAfterDeletion(this.formGroup, 'SUBGROUP', elementNumber);
      }, 200);

      // 🔧 FIX 2026-02-26: Notifier le service pour replier les autres accordéons du même type
      // et garder ouvert uniquement le nouveau créé
      const groupType = this.getGroupType(subGroup.id);
      if (groupType) {
        // Petit délai pour permettre au DOM de se mettre à jour avec le nouveau groupe
        setTimeout(() => {
          this.eformAccordionService.collapseOthers(groupType, subGroup.id);
        }, 100);
      }
    }
  }

  /**
   * 🔧 FIX 2026-02-26: Extrait le type de groupe à partir d'un ID
   * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
   */
  getGroupType(elementId: string): string {
    return this.eformAccordionService.extractGroupType(elementId);
  }

  isRepeatableField(field) {
    if (field._repeatable) {
      let tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2);
      return tempJsonPath + '_INDEX_' + (this.eformDataService.getArray(field, this.formGroup, this.repeatablePathWithIndex, tempJsonPath)) + '_SEPSEP_';
    } else if (field.isJsonPathAlreadyUsed) {
      let tempJsonPath;
      let tmpPath;
      if (this.repeatablePathWithIndex) {
        tmpPath = field?.jsonPath?.replace(this.repeatablePathWithIndex.slice(0, this.repeatablePathWithIndex.indexOf('val')), '');
        tmpPath = tmpPath?.slice(0, tmpPath?.indexOf('[]'));
        tempJsonPath = field.jsonPath.slice(0, field.jsonPath.indexOf(tmpPath) + tmpPath.length);
      } else {
        tempJsonPath = field?.jsonPath?.slice(0, field?.jsonPath?.indexOf('[]'))
      }
      let pathElements = tempJsonPath.split('.');
      let tempControl = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex);
      let index = 0;
      if (Array.isArray(tempControl?.controls)) {
        let count = 0;
        const afterElement = field?.jsonPath?.replaceAll('[]', '').split('.')[field?.jsonPath?.replaceAll('[]', '').split('.').indexOf(tmpPath) + 1]
        for (const element of tempControl?.controls) {
          if (element.get(afterElement)) {
            count++
          }
        }
        index = count;
      }
      return tempJsonPath + '[]' + '_INDEX_' + index + '_SEPSEP_';
    } else {
      return '';
    }
  }

  getRepeatablePathWithIndexForInput = (field): string => {
    if (field.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici - il est partagé entre tous les inputs
      return pathToReturn + this.isRepeatableField(field) + field.jsonPath + '_INDEX_' + (this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0');
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathForDuplicableElement = (): string =>{
    return this.repeatablePathForElementDuplicable
  }

  getRepeatablePathWithIndexForSubGroup = (subGroup, isForDelete?): string => {
    if (subGroup.jsonPath) {
      let pathToReturn = '';
      if (!this.repeatablePathWithIndex?.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      let index = this.eformDataService.getArray(subGroup, this.formGroup, this.repeatablePathWithIndex, undefined, undefined, undefined, undefined, undefined, isForDelete);
      this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, subGroup.jsonPath, Number(index), undefined, isForDelete)
      return pathToReturn + subGroup.jsonPath + '_INDEX_' + (index);
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  newField($event) {
    const field: Field = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.group.fields.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(field.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    field.id = field.id.split('_')[0] + '_' + elementNumber;
    const indexToSplice = this.group.fields.filter(el => el.id.startsWith($event.id)).length
    this.group.fields.splice((this.group.fields as any).findIndex(el => el.id === $event.id) + indexToSplice, 0, field);


    this.repeatablePath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2) + '_SEPSEP_' + (elementNumber);
    // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici car il est partagé

  }

  deleteField($event: any) {
    this.group.fields = this.group.fields.filter(obj => obj !== $event);
    let deletedFieldIndex = +$event.id.split('_')[1];
    //On decale de 1 tous les id supérieurs à celui supprimé pour rester syncro avec les controls
    this.group.fields.filter(f => f.id.includes('_')).forEach(f => {
      let splittedId = f.id.split('_');
      let actualIndex = +splittedId[1];
      if (actualIndex > deletedFieldIndex) {
        let newIndex = actualIndex - 1;
        f.id = splittedId[0] + '_' + newIndex;
      }
    });
  }

  deleteSubGroup($event: any) {
    // 🔧 FIX 2026-02-16: On récupère l'index AVANT de modifier la liste des sous-groupes
    // pour garantir que l'index utilisé pour la suppression du contrôle est correct
    let indexToDelete = 0;
    if ($event.repeatedId) {
      indexToDelete = $event.repeatedId.slice(-1)[0];
    } else {
      indexToDelete = 0;
    }

    // 🔧 FIX 2026-02-16: Calculer le repeatablePathWithIndex AVANT de modifier les IDs
    // Cela garantit que le chemin utilisé correspond au contrôle à supprimer
    const repeatablePathForDelete = this.getRepeatablePathWithIndexForSubGroupWithExplicitIndex($event, indexToDelete);

    this.group.subGroups = this.group.subGroups.filter(obj => obj !== $event);

    this.group.subGroups.filter(subGroup => subGroup.id.includes($event.id.split("_")[0])).forEach(subGroup => {
      if (subGroup.repeatedId && subGroup.repeatedId.slice(-1)[0] > indexToDelete) {
        subGroup.repeatedId.push(subGroup.repeatedId.pop() - 1);
        subGroup.id = subGroup.id.split("_")[0];
        subGroup.repeatedId.forEach(id => subGroup.id += '_' + id);
        subGroup.subSubGroups = this.eformElementsService.updateIdsRecursively(subGroup.subSubGroups, [...subGroup.repeatedId]);
      }
      if (!$event.id.includes("_") && subGroup.repeatedId.slice(-1)[0] === 0) {
        subGroup.id = subGroup.id.slice(0, -2);
      }
    });

    //On supprime le groupe du formulaire avec l'index explicite
    let pathElements: Array<string> = $event.jsonPath.split('.');
    pathElements.pop();
    this.formGroup = this.stepperBuilderService.removeLastControl(this.formGroup, pathElements, repeatablePathForDelete, indexToDelete, $event.listname);
    this.isDeletable($event.id);

    this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);

    // 🔧 FIX 2026-04-21: Forcer le rescan des flatFields après suppression d'un sous-groupe répétable
    // (ex: GR-Tenderer). Sans ce rescan, les conditions COUNT_* (comme celle de OPT-170-Tenderer
    // "Chef de file" qui dépend du nombre de OPT-300-Tenderer) ne sont pas réévaluées,
    // car les flatFields contiennent encore les anciennes entrées du sous-groupe supprimé.
    this.eformConditionsV2Service.forceRescanAfterDeletion(this.formGroup, 'SUBGROUP', indexToDelete);
  }

  /**
   * 🔧 FIX 2026-02-16: Nouvelle méthode pour calculer le repeatablePathWithIndex avec un index explicite
   * Utilisée lors de la suppression pour garantir que l'index correct est utilisé
   */
  private getRepeatablePathWithIndexForSubGroupWithExplicitIndex = (subGroup, explicitIndex: number): string => {
    if (subGroup.jsonPath) {
      let pathToReturn = '';
      if (!this.repeatablePathWithIndex?.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      return pathToReturn + subGroup.jsonPath + '_INDEX_' + explicitIndex;
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getIndex(id: string) {
    let element = id.split("_");
    return {value: id.split("_")[element.length - 1], bool: element.length > 1};
  }

  emitDonneePreference(preference: Preference) {
    this.preferenceSelected.emit(preference);
  }

  chargeDonneePreference(preference: Preference) {
    // ✅ FIX 2025-12-18: Désactiver les conditions pendant le chargement des préférences
    // pour permettre le remplissage des champs conditionnels (ex: BT-507-Organization-Company)
    this.eformConditionsV2Service.setLoadingPreference(true);

    let pathElements = this.group.jsonPath.split('.');
    pathElements.pop();
    const form = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex)
    for (let index = 0; index < preference?.content?.values.length; index++) {
      const element = preference?.content?.values[index];
      if (element.value !== null) {
        this.setPreference(form, element);
      }
    }

    // ✅ FIX 2025-12-18: Réactiver les conditions après le chargement avec un délai
    // pour laisser le temps aux valeurs de se propager dans le formulaire
    setTimeout(() => {
      this.eformConditionsV2Service.setLoadingPreference(false);
    }, 100);
  }

  setPreference(form, element) {
    let current = form;
    const arrays = element.code.split('_');
    for (let j = 0; j < arrays.length; j++) {
      if (j === arrays.length - 1) {
        current = current?.controls[arrays[j]]?.controls['val'].setValue(element.value);
      } else {
        if (arrays[j].includes('[]')) {
          current = current?.controls[arrays[j].replace('[]', '')]?.controls[0];
        } else {
          current = current?.controls[arrays[j]];
        }
      }
    }
  }

  parcoursUtilisateur(group) {
    return group.parcoursUtilisateur?.messageInfo;
  }

}
